import React from "react";
import { IconButton } from "../../Body/Styles/Body";
import { CheckIconV2, CloseIcon } from "../../Styles";
import { EditOutlineIcon } from "./Icons";

const sharedTextButtonStyles = {
  color: "#666",
  fontWeight: 600,
  fontSize: "14px",
  backgroundColor: "lightgrey",
  borderRadius: "6px",
  height: 36,
  width: 72,
  padding: 0,
};

const sharedApproveBorderStyles = {
  border: "1px solid",
  borderColor: "success.main",
  borderRadius: "6px",
  height: 36,
  width: 36,
  padding: 0,
};

const sharedRejectBorderStyles = {
  border: "1px solid",
  borderColor: "error.main",
  borderRadius: "6px",
  height: 36,
  width: 36,
  padding: 0,
};

export const CancelButton = ({ onClick }) => (
  <IconButton size="small" onClick={onClick} sx={sharedTextButtonStyles}>
    Cancel
  </IconButton>
);

export const EditButton = ({ onClick }) => (
  <IconButton size="small" onClick={onClick} sx={sharedTextButtonStyles}>
    <EditOutlineIcon /> Edit
  </IconButton>
);

export const ApproveButton = ({ onClick }) => (
  <IconButton
    size="small"
    color="success"
    onClick={onClick}
    sx={sharedApproveBorderStyles}
  >
    <CheckIconV2 />
  </IconButton>
);

export const RejectButton = ({ onClick }) => (
  <IconButton
    size="small"
    color="error"
    onClick={onClick}
    sx={sharedRejectBorderStyles}
  >
    <CloseIcon fontSize="small" />
  </IconButton>
);
